import { ICreateCoachesStore } from '../models/create-coaches.model';

export enum CreateCoachesActionTypes {
    ASYNC_GET_INFO_REALM = '@create-coaches/ASYNC_GET_INFO_REALM',
    CONTROL_IS_LOADING_MODAL = '@create-coaches/CONTROL_IS_LOADING_MODAL',
    CONTROL_CURRENT_STEPS = '@create-coaches/CONTROL_CURRENT_STEPS',
    CONTROL_CURRENT_USER = '@create-coaches/CONTROL_CURRENT_USER'
}

export interface IAction {
    type: CreateCoachesActionTypes,
    payload: any
};


const INITIAL_STATE: ICreateCoachesStore = {
    isLoadingModal: false,
    currentUser: undefined,
    currentSteps: 0
}

export const reducer = (state: ICreateCoachesStore = INITIAL_STATE, action: IAction ) => {
    switch(action.type){
        case CreateCoachesActionTypes.CONTROL_CURRENT_STEPS:
            return { ...state, currentSteps: action.payload }
        case CreateCoachesActionTypes.CONTROL_CURRENT_USER:
            return { ...state, currentUser: action.payload }
        case CreateCoachesActionTypes.CONTROL_IS_LOADING_MODAL:
            return { ...state, isLoadingModal: action.payload }
        default:
            return state
    }
}

export const asyncGetUserInfo = (email: string) => ({
    type: CreateCoachesActionTypes.ASYNC_GET_INFO_REALM,
    payload: email ? email.trim() : email
})

export const controlCurrentSteps = (value: number) => ({
    type: CreateCoachesActionTypes.CONTROL_CURRENT_STEPS,
    payload: value
})

export const controlCurrentUser = (value: any) => ({
    type: CreateCoachesActionTypes.CONTROL_CURRENT_USER,
    payload: value
});

export const controlIsLoadingModal = (value: boolean) => ({
    type: CreateCoachesActionTypes.CONTROL_IS_LOADING_MODAL,
    payload: value
})

export default reducer;